import axios from "../utils/axios";

export const getNotifications = (userName) => {
    return axios.get(`/NotificationHistory/GetUnreadNotificationsOfUser?username=${userName}`);
};

export const getNotificationHistory = (notificationId) => {
    return axios.post(`/NotificationHistory/ReadNotification?notificationHistoryId=${notificationId}`);
};

export const readUserNotification = (userName) => {
    return axios.post(`/NotificationHistory/SetAsReadNotificationsOfUser?userName=${userName}`);
};

export const setSubscribeNotification = (subscription) => {
    return axios.post("/Notification/Subscribe", subscription);
};

export const getNotificationSubscriptionOfUser = (userName) => {
    return axios.get(`/Notification/GetNotificationSubscriptionOfUser?userName=${userName}`);
};

export const deleteSubscription = (payload) => {
    return axios.post(`/Notification/DeleteSubscription`, payload);
};

export const getNotificationLanguages = () => {
    return axios.get("/Languages");
};

export const setNotificationLanguage = (payload) => {
    return axios.post(`/Notification/Subscriptions/CurrentUser/Language?languageId=${payload}`);
};
